import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-homefull",
  "use": "icon-homefull-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-homefull\">\n  <path fill=\"currentColor\" d=\"M10 4L4.462 9.538V16h4.615v-4.615h1.846V16h4.615V9.538z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol